
const baseUrl = "wss://qwj.symboot.com/wss";
let webSocketIP = "";
let socket = "";
let socketOpen = false;
let socketMsgQueue =[];

export const createSocket = tid => {
  if(!socket) {
    console.log('建立websocket連接')
    webSocketIP = `${baseUrl}`;
    socket = new WebSocket(webSocketIP);
    socket.onopen = onopenWs;
    socket.onmessage = onmessageWs;
    socket.onerror = onerrorWs;
    socket.onclose = oncloseWs;
  } else {
    console.log("已經建立了websocket連接")
  }
}

/**打開WS之後發送心跳 */
const onopenWs = event => {
  socketOpen = true;
  console.log("鏈接成功", event);
  // socket.send(JSON.stringify({data: "websocket client connect test message-測試信息"}));
  for (let i = 0; i < socketMsgQueue.length; i++){
    sendWSPush(socketMsgQueue[i])
  }
  socketMsgQueue = []
}

const oncloseWs = event => {
  console.log("斷開鏈接", event);
}

/**連接失敗重連 */
const onerrorWs = event => {
  console.log("出現錯誤", event);
  socket.close()
  createSocket() //重連
}

/**WS數據接收統一處理 */
const onmessageWs = event => {
  console.log("==WS數據接收統一處理==", event.data)
  window.dispatchEvent(new CustomEvent('onmessageWS', {
      detail: {
        data: event.data,
      }
  }))
}
/*斷開socket鏈接*/
export function disConnectSocket() {
  if(socket) {
    socket.close()
  }
}

/**發送數據
 * @param eventType
 */
export function sendWSPush(eventTypeArr) {
  if(eventTypeArr == null || eventTypeArr === '') return; 
  const obj = eventTypeArr;
  if(socketOpen) {
    if (socket !== null && socket.readyState === 3) {
      socket.close()
      createSocket() //重連
    } else if (socket.readyState === 1) {
      socket.send(JSON.stringify(obj))
    } else if (socket.readyState === 0) {
      setTimeout(() => {
        socket.send(JSON.stringify(obj))
      }, 3000)
    }
  } else {
    socketMsgQueue.push(eventTypeArr)
  }

  
}